import { useContext } from 'react';

import { ShortcutMenuContext } from '../components/ShortcutMenuContext';

export const useShortcutMenu = () => {
    const context = useContext(ShortcutMenuContext);

    if (!context) {
        throw new Error('useShortcutMenu must be used within ShortcutMenuProvider');
    }

    return context;
};
